import { BaseTenantLinksDto } from '../../shared/dtos/base-tenant-links.dto';

/**
 * Vehicle road worthy check links DTO
 */
export class VehicleRoadWorthyCheckLinksDto extends BaseTenantLinksDto {}
